import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=ff4142b0&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=ff4142b0&prod&scoped=true&lang=css"
import style1 from "./Products.vue?vue&type=style&index=1&id=ff4142b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4142b0",
  null
  
)

export default component.exports